import * as React from "react";
import MarkerClusterGroup from "@changey/react-leaflet-markercluster";
import "@changey/react-leaflet-markercluster/dist/styles.min.css";
import { MarkerOnlineContainer,MarkerOfflineContainer } from "./markerContainer";
import { ReactComponent as CartAvailableIcon } from "../../assets/icons/cartIcons/cart_avalible.svg";
import { ReactComponent as CartBusyIcon } from "../../assets/icons/cartIcons/cart_busy.svg";
import { ReactComponent as CartIconForMapCluster } from "../../assets/icons/cartIcons/cartIconForMapCluster.svg";
import { renderToStaticMarkup } from "react-dom/server";
import L from 'leaflet';

const cartIconAvailable = renderToStaticMarkup(<CartAvailableIcon />);
const cartIconBusy = renderToStaticMarkup(<CartBusyIcon />);
const CartIconForMapClusterRender = renderToStaticMarkup(<CartIconForMapCluster />);

const createClusterCustomIcon = (cluster) => {
  return L.divIcon({
    html: `<span>${cluster.getChildCount()}</span>`,
    className: 'marker-cluster-custom',
    iconSize: L.point(30, 30, true),
  });
}

const cartClusterIcon=(cluster)=> L.divIcon({
  className: "",
  html: `
  <div> 
  <div class="marker-cluster-custom">
    ${CartIconForMapClusterRender} ${cluster.getChildCount()}
    <div class="marker-cluster-custom-arrow-down"></div>
    </div>
    ${cartIconAvailable}
  </div>`,
 
});

function MarkerClusterContainer({
  mapRef,
  width,
  height,
  OnlieMarkers,
  OfflineMarkers,
  cartToShowPath,
  setCartToShowPath,
  cartsPaths,
  setOnHoverCart,
  onHoverCart,
  defaultPoint,
  selectedCart,
  setSelectedCart,
  setStaticPopup
}) {
  React.useEffect(() => {
    if (mapRef) {
      mapRef.invalidateSize();
    }
  }, [mapRef, width, height]);


  

  return (
    <>

    {/* offline marker  */}
{/*     
      <MarkerClusterGroup
        iconCreateFunction={cartClusterIcon}
        spiderfyDistanceMultiplier={5}
      >
      
      {
        Array.isArray(OfflineMarkers) && OfflineMarkers.map((cartInfo) => 
          (
            <MarkerOfflineContainer
              cartInfo={cartInfo}
              position={defaultPoint}
              key={cartInfo.cart_id+111}
              id={cartInfo.cart_id}
              setOnHoverCart={setOnHoverCart}
              onHoverCart={onHoverCart}
            />
          )
        )
      }
      </MarkerClusterGroup> */}



      <MarkerClusterGroup
        iconCreateFunction={cartClusterIcon}
        spiderfyDistanceMultiplier={5}
      >
      {
        Array.isArray(OnlieMarkers) && OnlieMarkers.map((cartInfo) => 
      ( 
        <MarkerOnlineContainer
          cartInfo={cartInfo}
          position={cartInfo.cart_location}
          key={cartInfo.cart_number+111}
          id={cartInfo.cart_number}
          cartToShowPath={cartToShowPath}
          setCartToShowPath={setCartToShowPath}
          cartsPaths={cartsPaths}
          setOnHoverCart={setOnHoverCart}
          onHoverCart={onHoverCart}
          selectedCart ={selectedCart}
          setSelectedCart={setSelectedCart}
          setStaticPopup={setStaticPopup}
        />
      )
    )
  }
  
      </MarkerClusterGroup>
    </>
  );
}

export default MarkerClusterContainer;

// export default React.memo(MarkerClusterContainer, (props, nextProps) => {
//   if (props.width !== nextProps.width || props.height !== nextProps.height) {
//     props.mapRef.invalidateSize();
//     return true;
//   }
// });
